import React from "react";
import { Switch, Route } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import Nav from "../../components/Static/Nav";

import routes from "../../routes";

export default function TheCreatorProblem({ ...rest }) {
  return (
    <div>
      <Nav headerClass="transparent-header"/>

      <div className="wf-section">
        <div className="w-container">
          <h1 className="blog-title-2">
            The Creator Problem: Make 1,000 followers feel like 1,000,000
          </h1>
          <div
            style={{ backgroundImage: 'url("./img/createorblogheader.png")' }}
            className="div-block-24"
          ></div>

          <div className="content">
            <div className="rich-text-block w-richtext">
              <h3>
                <strong>The Problem&nbsp;</strong>
              </h3>
              <p>
                Let’s state the obvious: Content Creators are the new
                celebrities. And the coolest thing about this shift is that it
                matters less and less now, the size of your following! Platforms
                like Tik Tok allow you to grow quickly, giving you an
                opportunity to share your personality and interests with
                thousands and thousands of people. “Going viral” and amassing
                millions of followers is an exhilarating and infectious feeling
                and is something coveted by pretty much everyone. One of the
                reasons people strive for such high follower counts is mainly
                because of the financial gain it can provide! More followers
                equal more of an audience to do things like sell merch to, have
                subscribe to your channels, and share/view your content.
              </p>
              <p>‍</p>
              <p>
                <strong>
                  <em>
                    Now here is the problem for Creatives - How do I amass
                    enough of a following to make a living?{" "}
                  </em>
                </strong>
              </p>
              <p>
                In our last &nbsp;
                <a
                  target="_blank"
                  href="/can-anyone-be-a-content-creator-7-tips-on-how-to-get-started"
                >
                  
                  blog post
                </a>
                , we revealed that the only way to gain a super loyal following
                is to be open and genuine to your fans. Let them feel a part of
                your club and let them get to know you on a personal level.
                While we are not saying, make content just for views or “do it
                for the Vine” lol, we are saying that attention is the currency
                that wins in the creator economy and{" "}
                <strong>individuality </strong>breeds attention. <br />
              </p>
              <h3>
                <strong>The Solution</strong>
              </h3>
              <p>
                For most creators, attention is fleeting. This is an issue
                because if you cannot capture the constant interest of your
                community, you cannot take the next step in benefiting from
                being a creator. Leveraging the loyalty of a small number of
                your fans, while still catering to the majority is a great
                approach to retaining the attention of your community and in
                turn, growing the community. &nbsp; <em>‍</em>
              </p>
              <p>
                <em>Wired</em> editor Kevin Kelly’s “1,000 true fans” first
                posed this framework. His belief is that creators only need to
                engage a modest base of <em>true fans</em>. He calls them “Those
                who will buy anything you produce,” and they are extremely
                important for your growth as a creator He believes embracing
                online networks lets creators bypass traditional gatekeepers
                &amp; middlemen, and get paid directly by their true and
                committed fan-base. This would also allow them to live
                comfortably off the returns.
              </p>
              <p>
                Quite cool sounding right? But it is not trivial, so how do you
                do it? As we have said, it always starts with your followers.
                And if we take a closer look, we will see that followers are
                actually broken up into a tiered system.&nbsp;
              </p>
              <p>
                <strong>
                  Tier 1 is your base-level follower who just enjoys your
                  content
                </strong>
              </p>
              <ul role="list">
                <li>
                  They may or may not even follow you (depending on the
                  platform).
                </li>
                <li>
                  They only view your content and don’t often share, like, or
                  comment.&nbsp;
                </li>
              </ul>
              <p>
                <strong>Tier 2 is an interested follower</strong>
              </p>
              <ul role="list">
                <li>
                  They have probably searched for more info about you which has
                  led to a deeper connection.
                </li>
                <li>
                  They feel more than followers and that they know you as a
                  friend would.
                </li>
                <li>
                  They are an active supporter - sharing your content and
                  constantly engaging.
                </li>
              </ul>
              <p>
                <strong>Tier 3 is an obsessed follower&nbsp;</strong>
              </p>
              <ul role="list">
                <li>
                  They have done more than their due diligence and have learned
                  exclusive things!&nbsp;&nbsp;
                </li>
                <li>
                  They feel a part of the club and identify with or form groups
                  surrounding your brand.
                </li>
                <li>
                  They buy merch, show up for tangible offerings and spread you
                  and your brand by word of mouth to friends and
                  peers.&nbsp;&nbsp;&nbsp;&nbsp;
                </li>
              </ul>
              <h3>
                <strong>
                  Here are 2 simple ways you can start converting your followers
                  to tiers 2 &amp; 3:&nbsp;
                </strong>
              </h3>
              <ul role="list">
                <li>
                  Provide a path for your tier 1 followers to learn a bit more
                  about you and learn exclusive things about you. Make it a
                  community or club where everyone is brought together because
                  they are “in the know” and everyone’s common interest is you.
                  Be sure to make this valuable through tangible things like
                  exclusive events, meet-ups, merch (Creative examples:{" "}
                  <a href="https://www.instagram.com/ilikeyou/?hl=en">
                    Issac Hindin-Miller - Ilikeyou
                  </a>
                  ,
                  <a href="https://www.instagram.com/pewdiepie/?hl=en">
                    Pewdiepie - Bro army
                  </a>
                  )
                </li>
                <li>
                  Diminish the barrier to access other forms of your personal
                  content like music, lifestyle, other interests, and BTS
                  (behind the scenes) content. A great example of this is
                  Keeping Up With the Kardashians!
                </li>
              </ul>
              <p>‍</p>
              <p>
                All three tiers of followers are important so it's best to be
                conscious of this as you structure your community building. In
                addition to being conscious of this tiered structure, being
                aware of the changes in the traditional creator-follower
                relationship is also helpful. We like to call what was
                previously popular, the <em>donation</em> model. This is where
                followers support their favorite creators in the form of gifts
                and other ways that solely benefit the creator. What we are
                transitioning to now is the <em>value</em> model - where
                followers are very willing to pay because there are benefits for
                them as well. This model banks on the psychology of followers
                paying for something, whether it be merch, access to exclusive
                content or even the ability to directly contact creators and
                seeing the creator as the middleman between them and this value.{" "}
                <br />
                <br />
              </p>
              <p>
                Remember, you are more than the content you have gone viral for!
                Showing off your individuality is the best way to convert your
                tier 1 followers to tier 2. Tagg is great at helping you
                genuinely brand and allowing each part of your brand to co-exist
                without clashing. Give your community of followers an easy way
                to get to know the real you and they will become more
                loyal!!&nbsp;
              </p>
              <p>
                <br />
              </p>
            </div>
          </div>
        </div>
    
      
      <div className="blog-subscribe wf-section"><div className="w-container"><div className="div-block-17"><div className="w-form"><form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" className="form" aria-label="Email Form 2"><input type="tel" className="text-field-5 w-input" maxlength="256" name="name-3" data-name="Name 3" placeholder="Enter your phone number" id="name-3"/> <input type="submit" value="Subscribe" data-wait="Please wait..." className="button w-button" /></form><div className="success-message-2 w-form-done" tabindex="-1" role="region" aria-label="Email Form 2 success"><div>Thank you! Your submission has been received!</div></div><div className="w-form-fail" tabindex="-1" role="region" aria-label="Email Form 2 failure"><div className="text-block-13">Oops! Something went wrong while submitting the form.</div></div></div></div></div><div className="w-container"><div className="text-block-12">Download Tagg</div><div className="div-block-23"><div className="text-block-15"><strong className="bold-text-5">Create your profile below 👇</strong></div></div><div className="div-block-30"><a href="https://apps.apple.com/us/app/tagg-powered-by-taggid-inc/id1537853613" target="_blank" className="button w-button">Download</a></div><div className="div-block-17"><div className="w-form"><form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" className="form" aria-label="Email Form 2"><input type="tel" className="text-field-5 w-input" maxlength="256" name="name-3" data-name="Name 3" placeholder="Enter your phone number" id="name-3" /> <input type="submit" value="Subscribe" data-wait="Please wait..." className="button w-button" /></form><div className="success-message-2 w-form-done" tabindex="-1" role="region" aria-label="Email Form 2 success"><div>Thank you! Your submission has been received!</div></div><div className="w-form-fail" tabindex="-1" role="region" aria-label="Email Form 2 failure"><div className="text-block-13">Oops! Something went wrong while submitting the form.</div></div></div></div></div></div>
      </div>
    </div>
  );
}
